import Component from './basket'

export default Component